import { createFileRoute } from "@tanstack/react-router";
import DeHelp from "@/pages/help/DeHelp";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/help/")({
  head: () => routeHead("/de/help/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <DeHelp />
  );
}
